import { useState, type FormEvent } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";

export function LoginPage() {
  const { user, loading, signInGoogle, signInEmail, startMfaPlaceholder } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [mfaUrl, setMfaUrl] = useState<string | null>(null);
  const from = (location.state as { from?: string } | null)?.from ?? "/devices";

  if (!loading && user) {
    return <Navigate to={from} replace />;
  }

  async function onEmail(e: FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await signInEmail(email, password);
    } catch (err) {
      setError(String(err));
    }
  }

  return (
    <div className="page-narrow">
      <header>
        <h1>Fix123 Support Portal</h1>
        <p>
          Staff login for EyeTech remote support. Production URL:{" "}
          <code>https://portal.fix123.ca</code>. Sign in with company SSO or emulator
          email. MFA enrollment placeholder is available after login.
        </p>
      </header>

      <section className="panel">
        <h2>Authentication</h2>
        <div className="row">
          <button
            type="button"
            className="primary"
            onClick={() => {
              setError(null);
              void signInGoogle().catch((err) => setError(String(err)));
            }}
          >
            Sign in with Google (SSO placeholder)
          </button>
        </div>

        <form className="stack" onSubmit={onEmail}>
          <label>
            Email (emulator)
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              autoComplete="username"
              required
            />
          </label>
          <label>
            Password
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              autoComplete="current-password"
              required
            />
          </label>
          <button type="submit">Email sign-in</button>
        </form>

        {user ? (
          <div className="row" style={{ marginTop: "0.75rem" }}>
            <button
              type="button"
              onClick={() => {
                void startMfaPlaceholder()
                  .then(setMfaUrl)
                  .catch((err) => setError(String(err)));
              }}
            >
              Start TOTP MFA (placeholder)
            </button>
          </div>
        ) : null}

        {error ? <p className="status err">{error}</p> : null}
        {mfaUrl ? <p className="status ok">{mfaUrl}</p> : null}
        <ul className="hints">
          <li>Requires custom claims: role (technician/admin), tenantId.</li>
          <li>Production: enforce MFA via IdP + APP_CHECK_ENFORCE.</li>
        </ul>
      </section>
    </div>
  );
}
